import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useAuth } from '../hooks/useAuth';
import { ReconnectingWebSocket, getSocketUrl } from '../socket';
import { getIdToken } from '../api/authFetch';

interface SocketContextType {
  socket: ReconnectingWebSocket | null;
}

export const SocketContext = createContext<SocketContextType | null>(null);

export const SocketProvider = ({ children }: { children: ReactNode }) => {
  const { groups, loading: authLoading } = useAuth();
  const [socket, setSocket] = useState<ReconnectingWebSocket | null>(null);

  useEffect(() => {
    if (!authLoading && groups && groups.length > 0) {
      const url = getSocketUrl();
      // Authenticates with the Cognito ID token; the backend reads the groups from it.
      const newSocket = new ReconnectingWebSocket(url, getIdToken, groups);
      setSocket(newSocket);

      return () => newSocket.close();
    } else if (!authLoading && (!groups || groups.length === 0)) {
      setSocket(prev => {
        if (prev) {
          // prev.close(); // si quisieras cerrar manualmente
          return null;
        }
        return prev; // si ya es null, no cambia nada
      });
    }
  }, [groups, authLoading]); // Re-run when groups or authLoading changes

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => {
  return useContext(SocketContext);
};